import React from 'react';
import { useTheme } from 'styled-components';
import { formatCurrency, formatShortDate, IEarlyPayTable, pricingCropKeys } from './pricingMatrix';

/** Early Pay ladder as the PDF prints it: one row per window, one column group per payment type. */
export function EarlyPayTable(props: { table: IEarlyPayTable; cornExists: boolean; soyExists: boolean })
{
	const { table, cornExists, soyExists } = props;
	const theme = useTheme();
	const crops = pricingCropKeys.filter(key => (key === 'Corn' && cornExists) || (key === 'Soybean' && soyExists));
	const cell: React.CSSProperties = { padding: '5px 10px', textAlign: 'right', whiteSpace: 'nowrap' };

	return (
		<table className='Pricing_EarlyPayTable' style={{ borderCollapse: 'separate', borderSpacing: 0, width: '100%', fontSize: theme.fontSizes.small }}>
			<thead>
				<tr>
					<th />
					{table.paymentTypes.map(type =>
						<th
							key={type}
							colSpan={crops.length + 1}
							style={{ ...cell, backgroundColor: theme.colors.mediumGrey, color: theme.colors.white, borderLeft: `2px solid ${theme.colors.white}` }}
						>
							{type}
						</th>)}
				</tr>
				<tr style={{ backgroundColor: theme.colors.ghxNeutral60, color: theme.colors.white }}>
					<th style={{ ...cell, textAlign: 'left' }}>Pay by</th>
					{table.paymentTypes.map(type =>
						<React.Fragment key={type}>
							{crops.map((crop, index) =>
								<th key={crop} style={{ ...cell, borderLeft: index === 0 ? `2px solid ${theme.colors.white}` : undefined }}>
									{crop === 'Corn' ? 'Corn/Unit' : 'Soy/Unit'}
								</th>)}
							<th style={{ ...cell, borderLeft: crops.length === 0 ? `2px solid ${theme.colors.white}` : undefined }}>Total</th>
						</React.Fragment>)}
				</tr>
			</thead>
			<tbody>
				{table.rows.map(row =>
					<tr key={row.date} style={{ fontWeight: row.isCurrent ? theme.fontWeights.bold : theme.fontWeights.normal }}>
						<td style={{ ...cell, textAlign: 'left', borderBottom: `1px solid ${theme.colors.lightestGrey}` }}>
							{formatShortDate(row.date)}
							{row.isCurrent &&
								<span style={{ marginLeft: 8, fontSize: theme.fontSizes.tiny, fontWeight: theme.fontWeights.normal, color: theme.colors.primary }}>
									current window
								</span>}
						</td>
						{table.paymentTypes.map(type =>
						{
							const option = row.byPaymentType[type];
							return (
								<React.Fragment key={type}>
									{crops.map((crop, index) =>
										<td key={crop} style={{ ...cell, color: theme.colors.mediumGrey, borderBottom: `1px solid ${theme.colors.lightestGrey}`, borderLeft: index === 0 ? `2px solid ${theme.colors.lightestGrey}` : undefined }}>
											{formatCurrency(option?.netPerBagByCrop[crop])}
										</td>)}
									<td style={{ ...cell, borderBottom: `1px solid ${theme.colors.lightestGrey}`, borderLeft: crops.length === 0 ? `2px solid ${theme.colors.lightestGrey}` : undefined }}>
										{formatCurrency(option?.netTotal)}
									</td>
								</React.Fragment>
							);
						})}
					</tr>)}
			</tbody>
		</table>
	);
}
